import React from 'react';
import {observer} from 'mobx-react';
import {Checkbox} from 'components';
import Description from './Description';
import {FormattedMessage} from 'react-intl';
import _ from 'lodash';

const PayrollPermissions = observer(({uiState}) => {
  const {payrollPermissions} = uiState;

  if (_.isEmpty(payrollPermissions)) return null;

  const payrollPermission = payrollPermissions[0];
  const payrollApproverPermission = payrollPermissions[1];

  return (
    <div>
      <div className='clearfix px2 pt2 pb1 border-top clickable bg-hover-smoke' onClick={() => { payrollPermission.toggle(); payrollApproverPermission.checked = false; }}>
        <div className='col col-1'>
          <Checkbox checked={payrollPermission.checked} onChange={() => { payrollPermission.toggle(); payrollApproverPermission.checked = false; }}/>
        </div>
        <div className='col col-5 pr4'>
          <div className='h3 medium'>
            <FormattedMessage id={`company_settings.permissions.${payrollPermission.featurePermission.name}`}/>
          </div>
        </div>
        <div className='col col-6'>
          <Description descriptionItems={payrollPermission.featurePermission.descriptionItems}/>
        </div>
      </div>
      <div className='clearfix px2 pb2 clickable bg-hover-smoke' onClick={() => payrollPermission.checked && payrollApproverPermission.toggle()}>
        <div className='col col-1'>&nbsp;</div>
        <div className='col col-5' key={payrollApproverPermission.featurePermission.name}>
          <label>
            <div className='inline-block pr2'>
              <Checkbox disabled={!payrollPermission.checked} checked={payrollApproverPermission.checked} onChange={() => payrollPermission.checked && payrollApproverPermission.toggle()}/>
            </div>
            <div className='h4 medium inline-block'>
              <FormattedMessage id={`company_settings.permissions.${payrollApproverPermission.featurePermission.name}`}/>
            </div>
          </label>
        </div>
        <div className='col col-6'>
          <Description descriptionItems={payrollApproverPermission.featurePermission.descriptionItems}/>
        </div>
      </div>
    </div>
  );
});

export default PayrollPermissions;
